module.exports = __webpack_public_path__ + "media/common/icon-weather-snowy-9490c5ce.svg";